import axios from "axios";
import React from "react";
import { useToken } from "../component";
import * as LoadingActions from "../state/Loading/actions";
import LoadingContext from "../state/Loading/Context";
import MessageContext from "../state/Message/Context";
import { message, notification } from "antd";

message.config({
  top: 60,
});

const options = {};

const requestConfig = (config) => {
  const { loadingDispatch, token } = options;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (loadingDispatch) loadingDispatch(LoadingActions.addLoading(true));
  return config;
};

const responseConfig = (response) => {
  const { loadingDispatch } = options;
  if (loadingDispatch) loadingDispatch(LoadingActions.removeLoading);
  return response;
};

/*const responseErrorHandler = (error) => {
  const { loadingDispatch, history } = options;
  if (loadingDispatch) loadingDispatch(LoadingActions.removeLoading);
  if (error.response) {
    const status = error.response.status;

    if (status === 403) {
      history.push("/acesso-negado");
      return Promise.reject(error);
    } else if (status !== 404 && status >= 400 && status < 500) {
      // eslint-disable-line
      //if (messageDispatch) messageDispatch(MessageActions.addErrorMessage([error.response.data]));
      return  notification.error({
        message: "Ops!",
        description: `${error.response.data}`,
        duration: 5,
      })
    } else if (status >= 500 && status <= 599) {
      return  notification.error({
        message: "Ops!",
        description: `${error.response.data}`,
        duration: 5,
      })
    } else {
      return Promise.reject(error);
    }
  }
};*/

const responseErrorHandler = (error) => {
  const { loadingDispatch, history } = options;

  if (loadingDispatch) loadingDispatch(LoadingActions.removeLoading);

  if (error.response) {
    const status = error.response?.status;
    const data = error.response?.data;
    const url = error.config?.url || "";

    if (
      (status === 404 && url.includes("/enderecos/")) ||
      (status === 500 && data.includes("Nenhum registro encontrado"))
    ) {
      return Promise.reject(error);
    }

    //  BLOQUEIO – JUNTA MÉDICA ou BLOQUEI PROVA DE VIDA

    if (
      data?.codigo === "BLOQUEIO_JUNTA_MEDICA" ||
      data?.codigo === "BLOQUEIO_PROVA_DE_VIDA"
    ) {
      return Promise.reject(error);
    }

    //  acesso negado
    if (status === 403) {
      history.push("/acesso-negado");
    }

    //  DECLARA UMA ÚNICA VEZ
    const mensagem =
      typeof data === "string" ? data : data?.mensagem || data?.message;

    /*if (
      status === 500 &&
      typeof mensagem === "string" &&
      mensagem.length > 200 &&
      (mensagem.includes("Perícia Médica") ||
        mensagem.includes("Junta Médica") ||
        mensagem.includes("perícia médica")) &&
      error.config?.url?.includes("/segurado/")
    ) {
      return Promise.reject(error);
    }*/

    if (status >= 400 && status <= 599) {
      notification.error({
        message: "Ops!",
        description: mensagem || "Erro inesperado",
        duration: 5,
      });
    }
  }

  return Promise.reject(error);
};

axios.interceptors.request.use(requestConfig, (error) => Promise.reject(error));

axios.interceptors.response.use(responseConfig, responseErrorHandler);

export default {
  InterceptorAxios: (history) => {
    const { loadingDispatch } = React.useContext(LoadingContext);
    const { messageDispatch } = React.useContext(MessageContext);
    const { token } = useToken();

    Object.assign(options, {
      loadingDispatch,
      messageDispatch,
      token,
      history,
    });
  },
};
